import { Component } from "react";
import "./footer.css";

class Footer extends Component {
  render() {
    return (
      <div className="footer-container">
        <p>© 2021 Aakash Pawar. All rights reserved.</p>
      </div>
    );
  }
}

export default Footer;
